/** Loading and empty-state primitives, styled as darkroom status messages. */

export function Loading({ label = "Developing…" }: { label?: string }) {
  return (
    <div className="state" role="status" aria-live="polite">
      <div className="spinner" aria-hidden="true" />
      {label}
    </div>
  );
}

export function EmptyState({ label }: { label: string }) {
  return <div className="state">{label}</div>;
}

export function ErrorState({ label }: { label: string }) {
  return (
    <div className="state" role="alert">
      <span style={{ color: "var(--safelight)" }}>✕ </span>
      {label}
    </div>
  );
}
